import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../core/services/app.service';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { NgClass } from '@angular/common';
import { ThemeCustomizerComponent } from './theme-customizer';
import { HeaderComponent } from './header';
import { SidebarComponent } from './sidebar';
import { FooterComponent } from './footer';
import { PermissionService } from '../core/services/api/permission.service';
import { InactivityService } from '../core/services/inactivity.service';
import { setPermissions } from '../store/actions/permission.actions';
import { InactivityWarningModalComponent,LoaderComponent } from '@sukna/shared'; 

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    imports: [NgClass, RouterModule, ThemeCustomizerComponent, HeaderComponent, FooterComponent, SidebarComponent, InactivityWarningModalComponent, LoaderComponent],
})
export class AppLayout {
    private inactivityService = inject(InactivityService);

    store: any;
    showTopButton = false;
    showWarningModal = false;
    countdown = 60;

    constructor(
        public storeData: Store<any>,
        private service: AppService,
        private router: Router,
        private _permissionService: PermissionService
    ) {
        this.initStore();
        this.inactivityService.init(); 
        this._permissionService.getPermissionByUser().subscribe((response) => { 
        this.storeData.dispatch(setPermissions({ data: response })); 
        });
    }
    headerClass = '';
    ngOnInit() {
        this.initAnimation();
        this.toggleLoader();
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
        this.inactivityService.showWarning$.subscribe(show => {
            this.showWarningModal = show;
        });

        this.inactivityService.countdown$.subscribe(countdown => {
            this.countdown = countdown;
        });
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => {});
        this.inactivityService.destroy();
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    onResumeSession() {
        this.inactivityService.resumeSession();
    }
}
